/** Logged-in retail customer (not guest, not admin). */
export const isRetailCustomerLoggedIn = (user, role) => {
  if (!user || role) return false;
  try {
    return !localStorage.getItem("userRole")?.includes("guest");
  } catch {
    return false;
  }
};

/** Routes where the side cart drawer is available (product browsing pages, not home). */
export const isCartDrawerRoute = (pathname = "") => {
  if (!pathname) return false;
  return (
    pathname.includes("/category/") ||
    pathname.includes("/search") ||
    pathname.includes("/sales")
  );
};
